import { render } from "./Home.vue?vue&type=template&id=f3e385e4"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f3e385e4&lang=css"
script.render = render

export default script